import { z } from 'zod';

import { actionIdSchema } from '../chat-ids';

export const blockModeSchema = z.enum(['Review', 'Result']);

export type BlockMode = z.infer<typeof blockModeSchema>;

export const questionnaireOptionSchema = z.object({
    additionalInformation: z.string().nullish(),
    label: z.string(),
    recommended: z.boolean().nullish(),
});

export type QuestionnaireOption = z.infer<typeof questionnaireOptionSchema>;

export const questionnaireQuestionSchema = z.object({
    actionId: actionIdSchema,
    allowCustomInput: z.boolean().nullish(),
    answer: z.string().nullish(),
    label: z.string(),
    options: z.array(questionnaireOptionSchema),
});

export type QuestionnaireQuestion = z.infer<typeof questionnaireQuestionSchema>;

export const questionnaireBlockSchema = z.object({
    blockId: z.uuid(),
    callbackUrl: z.string().nullish(),
    mode: blockModeSchema,
    questions: z.array(questionnaireQuestionSchema).min(1),
    title: z.string(),
    type: z.literal('questionnaire'),
});

export type QuestionnaireBlock = z.infer<typeof questionnaireBlockSchema>;
